<div class="form-group" [class.has-error]="!!errors()">
  <label class="control-label tw-flex tw-items-center tw-gap-spacing-25" [htmlFor]="controlName()">
    {{ schemaTranslations()?.getFieldTranslation(controlName()) }}
    @if (properties() | propertyIsFieldRequired:controlName()) {
      <span class="required with-hint">*</span>
    }
    @if (properties() | showPropertyArrayHint: controlName()) {
      <app-hint
          [tooltipText]="(properties() | propertyArrayHintText: controlName()) | translate:(properties() | propertyGetFields:controlName())"/>
    }
  </label>
  @if (formArrayControlsChanged$ | async) {
    @for (control of formArray.controls; track control; let i = $index) {
      <div
          [class.input--filled]="!!control.value">
        <div class="input-group">
          <input [type]="(properties() | propertyHasNumericValues:controlName()) ? 'number' : 'text'"
                 [formControl]="$any(control)"
                 class="form-control"
                 [id]="controlName() + '_' + i">
          <span (click)="removeFormControlAtIndex(i)" class="input-group-addon">
              <a class="btn-circle"><app-icon name="x" size="xs" class="tw-align-middle" /></a>
            </span>
        </div>
      </div>
    }
  }
  <span (click)="addFormControl()">
      <a class="btn-circle"><app-icon name="square-plus" size="xs" class="tw-align-top tw-h-[1.42857em] tw-items-center" /></a>
    </span>
</div>
